const CategoriaIcon = ({
  size,
  width = 42,
  height = 42,
  color = "#0468fb",
  ...rest
}) => {

  const w = width ?? size;
  const h = height ?? size;

  return (
    <svg viewBox="0 0 1080 1080" width={w} height={h} version="1.1" xmlns="http://www.w3.org/2000/svg" >

      <g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        fill={color} stroke="none">
        <path d="M6335 9425 c-216 -48 -417 -197 -531 -395 -26 -45 -68 -159 -86 -230
       -19 -81 -19 -2039 0 -2120 18 -71 60 -185 86 -230 89 -155 242 -289 404 -355
       139 -56 128 -56 1232 -53 1142 4 1053 -2 1225 83 205 101 353 278 417 500 l23
       80 0 1040 0 1040 -23 75 c-85 269 -272 459 -547 551 l-70 24 -1035 2 c-831 1
       -1047 -1 -1095 -12z m2105 -423 c81 -33 142 -82 188 -151 32 -49 42 -74 49
       -128 4 -38 8 -502 8 -1033 l0 -965 -39 -60 c-69 -105 -98 -135 -160 -165 -34
       -17 -88 -35 -121 -40 -80 -13 -1840 -13 -1919 0 -150 24 -278 143 -312 289
       -20 82 -20 1900 0 1982 32 137 152 255 292 288 23 5 441 9 999 8 l960 -2 55
       -23z"/>
        <path d="M2299 9310 c-105 -13 -185 -37 -279 -85 -244 -127 -401 -358 -430
       -635 -13 -128 -13 -1588 0 -1705 14 -118 33 -182 86 -285 95 -184 246 -316
       446 -389 126 -46 127 -46 1048 -46 823 0 879 1 945 19 282 75 492 266 579 528
       44 132 48 216 44 1098 -4 814 -4 826 -26 904 -39 139 -110 261 -212 365 -100
       101 -218 170 -370 214 -74 21 -84 21 -920 23 -465 1 -875 -2 -911 -6z m1774
       -439 c88 -35 153 -93 201 -181 l41 -75 0 -875 0 -875 -29 -59 c-40 -80 -108
       -146 -191 -187 l-70 -34 -865 0 -865 0 -65 31 c-115 54 -197 159 -220 283 -14
       73 -14 1609 0 1682 28 150 139 269 285 305 38 10 245 12 885 11 l835 -2 58
       -24z"/>
        <path d="M2132 5189 c-325 -54 -594 -315 -658 -637 -21 -110 -21 -2017 1
       -2120 68 -327 336 -582 663 -632 44 -7 412 -9 1067 -7 1119 3 1036 -2 1201 77
       200 96 350 267 421 480 l28 85 0 1060 0 1060 -32 91 c-101 290 -344 496 -643
       543 -80 13 -1970 13 -2048 0z m2088 -446 c118 -58 197 -161 220 -284 7 -37 10
       -381 8 -1000 -3 -877 -4 -947 -21 -989 -45 -115 -135 -203 -243 -240 -55 -19
       -87 -20 -1025 -20 -965 0 -968 0 -1026 21 -100 38 -173 104 -229 209 -18 33
       -19 80 -22 1024 -3 1073 -5 1026 51 1112 63 94 85 120 129 147 92 57 60 56
       1118 54 l975 -2 65 -32z"/>
        <path d="M6950 5055 c-457 -64 -850 -372 -1023 -802 -125 -310 -125 -666 0
       -976 264 -656 1001 -978 1668 -730 85 32 184 81 245 122 25 17 49 31 55 31 5
       0 181 -170 390 -379 413 -412 408 -407 511 -399 140 12 225 163 165 293 -12
       26 -145 166 -390 410 -204 203 -371 374 -371 380 0 5 20 40 44 77 161 248 226
       585 176 904 -40 248 -171 504 -354 689 -121 122 -207 184 -351 255 -245 121
       -497 162 -765 125z m410 -430 c195 -53 384 -184 503 -351 38 -53 97 -170 97
       -192 0 -7 10 -43 21 -80 12 -37 25 -81 30 -98 12 -42 11 -217 -2 -290 -41
       -235 -179 -449 -374 -581 -144 -97 -280 -142 -451 -150 -131 -6 -208 3 -325
       41 -397 126 -646 515 -602 939 22 206 107 382 258 532 127 126 260 198 446
       240 85 19 309 14 399 -10z"/>
      </g>
    </svg>

  );
};



export default CategoriaIcon;